// extracted by mini-css-extract-plugin
module.exports = {"navFooter":"nav-footer-desktop-module--nav-footer--bZx9W","navList":"nav-footer-desktop-module--nav-list--3UolN"};